import { styled } from "~/config/stitches";
import { Image as BaseImage } from "~/config/twicpics";

const Image = styled(BaseImage);

export { Image };
